import React, { useState } from 'react';
import { styled, Switch } from '@mui/material';

/** Track width/height and thumb size per design-system toggle size. Default is the original 32×16. */
const SWITCH_SIZES = {
    default: { width: 32, height: 16, thumb: 12 },
    large: { width: 44, height: 24, thumb: 20 },
};

export const CustomizedSwitch = ({ checked, handleClick, disabled = false, bgColor, checkedBgColor, size = 'default' }) => {
    const { width, height, thumb } = SWITCH_SIZES[size] || SWITCH_SIZES.default;
    const travel = width - height;

    const AntSwitch = styled(Switch)(({ theme }) => ({
        width,
        height,
        padding: 0,
        display: 'flex',
        '&:active': {
            '& .MuiSwitch-thumb': { width: thumb + 3 },
            '& .MuiSwitch-switchBase.Mui-checked': { transform: `translateX(${travel}px)` },
        },
        '& .MuiSwitch-switchBase': {
            padding: 2,
            '&.Mui-checked': {
                transform: `translateX(${travel}px)`,
                color: '#fff',
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: theme.palette.mode === 'dark' ? `${bgColor || '#177ddc'}` : `${checkedBgColor || '#1890ff'}`,
                },
            },
        },
        '& .MuiSwitch-thumb': {
            boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
            width: thumb,
            height: thumb,
            borderRadius: thumb / 2,
            transition: theme.transitions.create(['width'], { duration: 200 }),
        },
        '& .MuiSwitch-track': {
            borderRadius: height / 2,
            opacity: 1,
            backgroundColor:
                theme.palette.mode === 'dark' ? `${checkedBgColor || 'rgba(255,255,255,.35)'}` : `${bgColor || 'rgba(0,0,0,.25)'}`,
            boxSizing: 'border-box',
        },
    }));

    const [switchBool, setSwitchBool] = useState(false);

    const handleChange = () => {
        if (handleClick) {
            handleClick();
        } else {
            setSwitchBool((prevState) => !prevState);
        }
    };

    return (
        <AntSwitch inputProps={{ 'aria-label': 'ant design' }} checked={checked || switchBool} onClick={handleChange} disabled={disabled} />
    );
};
